import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SearchImgComponent } from "./components/search-img/search-img.component";
import { ListImageComponent } from "./components/list-image/list-image.component";
import { NavbarComponent } from "./components/navbar/navbar.component";
import { ErrorComponent } from "./shared/error/error.component";
import { SpinnerComponent } from "./shared/spinner/spinner.component";

import { HttpClientModule } from "@angular/common/http";
import { FormsModule } from "@angular/forms";

@NgModule({
  declarations: [
    AppComponent,
    SearchImgComponent,
    ListImageComponent,
    NavbarComponent,
    ErrorComponent,
    SpinnerComponent,
  ],
  imports: [BrowserModule, AppRoutingModule, FormsModule, HttpClientModule],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
